import React from 'react';
import { usePlatformUsdRates } from '../hooks/usePlatformUsdRates';
import { formatUsd } from '../utils/cryptoUsd';

interface DecimalAmountWithUsdProps {
  amount: string | number;
  currency: string;
  className?: string;
  usdClassName?: string;
}

const DecimalAmountWithUsd: React.FC<DecimalAmountWithUsdProps> = ({
  amount,
  currency,
  className,
  usdClassName = 'text-slate-500 text-xs',
}) => {
  const { toUsdDecimal, isLoading } = usePlatformUsdRates();
  const numeric = typeof amount === 'string' ? Number(amount) : amount;
  const usd = Number.isFinite(numeric) ? toUsdDecimal(numeric, currency) : null;

  return (
    <span className={className}>
      {amount}
      <span className="text-slate-500 ml-1 text-xs">{currency}</span>
      {!isLoading && usd != null && (
        <span className={usdClassName}> ({formatUsd(usd)})</span>
      )}
    </span>
  );
};

export default DecimalAmountWithUsd;
